// utils/localeStore.js
let ACTIVE_LOCALE = localStorage.getItem("userLocale") || "en-IN";

export function setGlobalLocale(locale) {
  ACTIVE_LOCALE = locale;
  localStorage.setItem("userLocale", locale);
}

export function getGlobalLocale() {
  return ACTIVE_LOCALE;
}
